/*
 * @Author: Christion.Young
 * @Date: 2021-01-20 16:50:35
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-14 14:00:00
 * @Description: Loading
 */
import Loading from "./index.vue";
import Vue from "vue";
export default () => {
  let LoadingComponent = Vue.extend(Loading);
  let child = new LoadingComponent({
    el: document.createElement("div"),
    data: {
      flag: false,
    },
    methods: {
      handlemount() {
        this.flag = true;
      },
      handleDestory() {
        this.flag = false;
      },
    },
  });
  document.body.appendChild(child.$mount().$el);
  return child;
};
